import { Component, OnInit, Input, Output , OnChanges, SimpleChanges, EventEmitter } from '@angular/core';

@Component({
    selector: 'sst-graph-list',
    template: 
    `<div class="text-center cursor mt-5" *ngFor="let graph of graphList" (click)="graphSelection(graph)"
        [class.active]="graph?.id == selectedGraph?.id" [class.is-disabled]="!graph.selectable">
        <img [src]="graph.image" class="chart-img">
        <p class="chart-label font-open-sans px-0"   >
            {{graph.title}}
        </p>    
    </div>`,
    styleUrls: ['./sst-graph-list.component.css']
})

export class SSTGraphListComponent implements OnInit, OnChanges {

    @Input() graphList: any;
    @Input() graphGenerated: boolean = false;

    @Output() selectGraph: EventEmitter<any> = new EventEmitter();

    selectedGraph:any;

    constructor(
    ) { }

    ngOnInit() {
        if(this.graphList && this.graphList.length > 0){
            if(!this.graphGenerated)
                this.graphSelection(this.graphList[0]);
        }            
    }

    ngOnChanges(changes: SimpleChanges) {
        // only run when property "data" changed
        if (changes['graphList']) {
            if(this.graphList && this.graphList.length > 0 && !this.graphGenerated){
                this.graphSelection(this.graphList[0]);
            }
        }
    }

    graphSelection(data){
        this.selectedGraph = data;
        this.selectGraph.emit(data);
    }
}


// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/self-service-tab/components/sst-graph-list/sst-graph-list.component.ts